export default __webpack_public_path__ + "static/media/Vinotemp@3x.a5e5a85a.png";